module.exports = __webpack_public_path__ + "img/56.4.NH3-N.f39eb636.png";